(function ($) {
    function getInt($element, attribute, fallback) {
        var value = parseInt($element.attr(attribute), 10);

        return Number.isNaN(value) ? fallback : value;
    }

    function getBool($element, attribute) {
        return $element.attr(attribute) === '1';
    }

    function getSlideBy($element) {
        return $element.attr('data-slide-by') === 'page' ? 'page' : 1;
    }

    function getNavText() {
        return [
            "<span class='sr-only'>Previous slide</span><i class='icon-angle-left' aria-hidden='true'></i>",
            "<span class='sr-only'>Next slide</span><i class='icon-angle-right' aria-hidden='true'></i>",
        ];
    }

    function cleanDuplicateControls($carousel) {
        $carousel.children('.owl-nav').not(':first').remove();
        $carousel.children('.owl-dots').not(':first').remove();
    }

    function syncCarouselWidth($carousel) {
        var $parent = $carousel.parent();
        var parentWidth = Math.floor($parent.innerWidth());

        if (parentWidth > 0) {
            $carousel.css('width', parentWidth + 'px');
        }
    }

    function refreshCarousel($carousel) {
        syncCarouselWidth($carousel);
        $carousel.trigger('refresh.owl.carousel');
        cleanDuplicateControls($carousel);
    }

    function initCarousel(selector, defaults) {
        if (!$.fn.owlCarousel) {
            return;
        }

        $(selector).each(function () {
            var $carousel = $(this);

            if ($carousel.data('ddOwlCarousel')) {
                return;
            }

            var desktopItems = getInt($carousel, 'data-items-desktop', defaults.desktopItems);
            var tabletItems = getInt($carousel, 'data-items-tablet', defaults.tabletItems);
            var mobileItems = getInt($carousel, 'data-items-mobile', defaults.mobileItems);
            var itemCount = getInt($carousel, defaults.countAttribute, 0);
            var hasMultiplePages = itemCount > desktopItems;
            var gap = getInt($carousel, 'data-gap', defaults.gap);
            var arrows = getBool($carousel, 'data-arrows');
            var dots = getBool($carousel, 'data-dots');
            var loop = getBool($carousel, 'data-loop');
            var autoplay = getBool($carousel, 'data-autoplay');
            var autoplayDelay = getInt($carousel, 'data-autoplay-delay', 4500);

            function responsiveOptions(items) {
                return {
                    items: items,
                    loop: loop && itemCount > items,
                    autoplay: autoplay && itemCount > items,
                };
            }

            syncCarouselWidth($carousel);

            $carousel.owlCarousel({
                margin: gap,
                items: desktopItems,
                slideBy: getSlideBy($carousel),
                loop: loop && hasMultiplePages,
                autoplay: autoplay && hasMultiplePages,
                autoplayTimeout: autoplayDelay,
                autoplayHoverPause: true,
                smartSpeed: 500,
                // Owl disables controls when all items fit at the active
                // breakpoint; desktop capacity must not disable mobile controls.
                nav: arrows,
                dots: dots,
                navText: getNavText(),
                responsive: {
                    0: responsiveOptions(mobileItems),
                    768: responsiveOptions(tabletItems),
                    1200: responsiveOptions(desktopItems),
                },
            });

            $carousel.data('ddOwlCarousel', true);
            cleanDuplicateControls($carousel);

            window.requestAnimationFrame(function () {
                refreshCarousel($carousel);
            });
        });
    }

    function initSingleSlideCarousel(selector) {
        if (!$.fn.owlCarousel) {
            return;
        }

        $(selector).each(function () {
            var $carousel = $(this);

            if ($carousel.data('ddOwlCarousel')) {
                return;
            }

            var slideCount = getInt($carousel, 'data-slide-count', 0);
            var hasMultipleSlides = slideCount > 1;
            var arrows = getBool($carousel, 'data-arrows');
            var dots = getBool($carousel, 'data-dots');
            var loop = getBool($carousel, 'data-loop') && hasMultipleSlides;
            var autoplay = getBool($carousel, 'data-autoplay') && hasMultipleSlides;
            var autoplayDelay = getInt($carousel, 'data-autoplay-delay', 4500);

            syncCarouselWidth($carousel);

            $carousel.owlCarousel({
                items: 1,
                margin: 0,
                loop: loop,
                autoplay: autoplay,
                autoplayTimeout: autoplayDelay,
                autoplayHoverPause: true,
                smartSpeed: 500,
                nav: arrows && hasMultipleSlides,
                dots: dots && hasMultipleSlides,
                navText: getNavText(),
            });

            $carousel.data('ddOwlCarousel', true);
            cleanDuplicateControls($carousel);

            window.requestAnimationFrame(function () {
                refreshCarousel($carousel);
            });
        });
    }

    function refreshCarousels() {
        $('.gallery-slider.owl-carousel, .block-cpt-slider.owl-carousel, .taxonomy-posts-slider.owl-carousel, .logos-slider.owl-carousel, .grid-card-slider.owl-carousel, .text-image-slider.owl-carousel').each(function () {
            var $carousel = $(this);

            if ($carousel.data('ddOwlCarousel')) {
                refreshCarousel($carousel);
            }
        });
    }

    function debounce(callback, delay) {
        var timer = null;

        return function () {
            window.clearTimeout(timer);
            timer = window.setTimeout(callback, delay);
        };
    }

    function initLightboxes() {
        if (!$.fn.lightGallery) {
            return;
        }

        $('.gallery-lightbox').each(function () {
            var $gallery = $(this);
            var isReference = $gallery.hasClass('referenzen-card');

            if ($gallery.data('ddLightGallery')) {
                return;
            }

            $gallery.lightGallery({
                selector: '.gallery-lightbox-item',
                share: true,
                download: true,
                rotate: false,
                showThumbByDefault: true,
                loop: false,
                thumbnail: true,
                allowMediaOverlap: true,
                toggleThumb: true,
                // Every project owns a separate gallery, including repeated blocks.
                hash: !isReference,
                exThumbImage: isReference ? 'data-thumb' : false,
            });

            if (isReference) {
                $gallery.on('onCloseAfter.lg.ddReference', function () {
                    var trigger = $gallery.find('.referenzen-card-link').get(0);
                    if (trigger && document.contains(trigger)) trigger.focus({ preventScroll: true });
                });
            }

            // Owl rebuilds clones without the original LightGallery handlers.
            // Open the matching original so clones do not duplicate gallery items.
            $gallery.on('click.ddLightGallery', '.owl-item.cloned .gallery-lightbox-item', function (event) {
                event.preventDefault();
                var index = $(this).attr('data-gallery-index');
                $gallery.find('.owl-item:not(.cloned) .gallery-lightbox-item').filter(function () {
                    return $(this).attr('data-gallery-index') === index;
                }).first().trigger('click');
            });

            $gallery.data('ddLightGallery', true);
        });
    }

    function initMarquees() {
        document.querySelectorAll('.block_marquee .marquee').forEach(function (marquee) {
            if (marquee.dataset.initialized) return;
            marquee.dataset.initialized = '1';

            var viewport = marquee.querySelector('.marquee-viewport');
            var track = marquee.querySelector('.marquee-track');
            var source = track.querySelector('.marquee-group');
            var items = Array.from(source.children).map(function (item) { return item.cloneNode(true); });
            var toggle = marquee.querySelector('.marquee-toggle');
            var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
            var lastWidth = 0;
            var frame = 0;
            var speed = Math.max(10, Math.min(150, parseInt(marquee.dataset.speed, 10) || 40));

            function rebuild() {
                lastWidth = viewport.clientWidth;
                marquee.classList.remove('is-ready');
                toggle.hidden = true;
                track.replaceChildren(source);
                source.replaceChildren.apply(source, items.map(function (item) { return item.cloneNode(true); }));
                if (!lastWidth || reducedMotion.matches) return;

                marquee.classList.add('is-ready');
                var sequenceWidth = source.getBoundingClientRect().width;
                if (!sequenceWidth) {
                    marquee.classList.remove('is-ready');
                    return;
                }

                // Each of the two identical groups must fill the entire viewport.
                var copies = Math.ceil((lastWidth + 1) / sequenceWidth);
                for (var i = 1; i < copies; i++) {
                    items.forEach(function (item) {
                        var copy = item.cloneNode(true);
                        copy.dataset.marqueeCopy = '1';
                        source.appendChild(copy);
                    });
                }
                var distance = source.getBoundingClientRect().width;
                track.appendChild(source.cloneNode(true));
                marquee.style.setProperty('--marquee-duration', (distance / speed) + 's');
                toggle.hidden = false;
            }

            function scheduleRebuild() {
                window.cancelAnimationFrame(frame);
                frame = window.requestAnimationFrame(rebuild);
            }

            toggle.addEventListener('click', function () {
                var paused = marquee.classList.toggle('is-paused');
                toggle.setAttribute('aria-pressed', String(paused));
                toggle.setAttribute('aria-label', paused ? toggle.dataset.playLabel : toggle.dataset.pauseLabel);
            });
            reducedMotion.addEventListener('change', scheduleRebuild);
            if ('ResizeObserver' in window) {
                new ResizeObserver(function () {
                    if (viewport.clientWidth !== lastWidth) scheduleRebuild();
                }).observe(viewport);
            } else {
                window.addEventListener('resize', scheduleRebuild);
            }
            if (document.fonts) document.fonts.ready.then(scheduleRebuild);
            rebuild();
        });
    }

    function initTimelines() {
        document.querySelectorAll('.block_timeline .timeline[data-highlight="1"]').forEach(function (timeline) {
            if (timeline.dataset.initialized) return;
            timeline.dataset.initialized = '1';
            var items = Array.from(timeline.children);
            if (items.length < 2) return;
            var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
            var frame = 0;
            var active = -1;

            function update() {
                frame = 0;
                timeline.classList.toggle('is-enhanced', !reducedMotion.matches);
                if (reducedMotion.matches) return;
                var anchor = window.innerHeight * .45;
                var index = 0;
                items.forEach(function (item, itemIndex) {
                    if (item.getBoundingClientRect().top <= anchor) index = itemIndex;
                });
                if (index === active) return;
                active = index;
                items.forEach(function (item, itemIndex) {
                    item.classList.toggle('is-active', itemIndex === index);
                    item.classList.toggle('is-past', itemIndex < index);
                });
            }

            function scheduleUpdate() {
                if (!frame) frame = window.requestAnimationFrame(update);
            }

            window.addEventListener('scroll', scheduleUpdate, { passive: true });
            window.addEventListener('resize', scheduleUpdate);
            reducedMotion.addEventListener('change', scheduleUpdate);
            if ('ResizeObserver' in window) new ResizeObserver(scheduleUpdate).observe(timeline);
            if (document.fonts) document.fonts.ready.then(scheduleUpdate);
            update();
        });
    }

    function initTestimonials() {
        if (!$.fn.owlCarousel) return;

        $('.testimonials-slider').each(function () {
            var $slider = $(this);
            if ($slider.data('ddTestimonials')) return;
            $slider.data('ddTestimonials', true);
            var $section = $slider.closest('.block_testimonials');
            var $controls = $section.find('[data-testimonials-controls]').filter(function () {
                return this.getAttribute('data-testimonials-controls') === $slider.attr('id');
            });
            var $status = $slider.siblings('.testimonials-status');
            var count = getInt($slider, 'data-review-count', 0);
            var loop = getBool($slider, 'data-loop');
            var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
            var userNavigation = false;

            function sync(event) {
                var api = event.relatedTarget;
                if (!api || !api.settings) return;
                var canSlide = count > api.settings.items;
                var index = api.relative(api.current()) || 0;
                $controls.prop('hidden', !canSlide);
                $controls.find('.testimonials-prev').prop('disabled', !canSlide || (!api.settings.loop && index === 0));
                $controls.find('.testimonials-next').prop('disabled', !canSlide || (!api.settings.loop && index >= api.maximum(true)));
                // Keep each review available once to assistive technology.
                $slider.find('.owl-item.cloned').attr('aria-hidden', 'true');
                if (event.type === 'translated' && userNavigation) {
                    $status.text('Bewertung ' + (index + 1) + ' von ' + count);
                    userNavigation = false;
                }
            }
            function move(direction) {
                var api = $slider.data('owl.carousel');
                if (!api || count <= api.settings.items) return;
                userNavigation = true;
                $slider.trigger(direction + '.owl.carousel', [reducedMotion.matches ? 0 : 450]);
            }
            function responsive(items) {
                return { items: items, loop: loop && count > items };
            }

            $slider.on('initialized.owl.carousel refreshed.owl.carousel translated.owl.carousel', sync);
            $slider.on('drag.owl.carousel', function () { userNavigation = true; });
            $slider.owlCarousel({
                items: 3,
                margin: 22,
                loop: loop && count > 3,
                slideBy: 1,
                autoplay: !reducedMotion.matches,
                autoplayTimeout: 5000,
                autoplayHoverPause: true,
                nav: false,
                dots: false,
                autoHeight: false,
                smartSpeed: reducedMotion.matches ? 0 : 450,
                responsive: { 0: responsive(1), 768: responsive(2), 1200: responsive(3) },
            });
            $controls.find('.testimonials-prev').on('click', function () { move('prev'); });
            $controls.find('.testimonials-next').on('click', function () { move('next'); });
            $slider.on('keydown', function (event) {
                if (event.target !== this || (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight')) return;
                event.preventDefault();
                move(event.key === 'ArrowLeft' ? 'prev' : 'next');
            });
            reducedMotion.addEventListener('change', function () {
                var api = $slider.data('owl.carousel');
                if (api) {
                    api.options.smartSpeed = reducedMotion.matches ? 0 : 450;
                    api.options.autoplay = !reducedMotion.matches;
                    $slider.trigger('refresh.owl.carousel');
                }
            });
            // Owl handles window resizing; observe the container as well (tabs/editor panels).
            if ('ResizeObserver' in window) {
                var lastWidth = $slider.parent().innerWidth();
                var refresh = debounce(function () { $slider.trigger('refresh.owl.carousel'); }, 100);
                new ResizeObserver(function () {
                    var width = $slider.parent().innerWidth();
                    if (Math.abs(width - lastWidth) > 1) { lastWidth = width; refresh(); }
                }).observe($slider.parent().get(0));
            }
        });
    }

    function initBeforeAfter() {
        document.querySelectorAll('[data-before-after]').forEach(function (comparison) {
            if (comparison.dataset.initialized === '1') return;
            var range = comparison.querySelector('.comparison-range');
            var divider = comparison.querySelector('.comparison-divider');
            if (!range || !divider) return;
            comparison.dataset.initialized = '1';

            function update() {
                var position = Math.max(0, Math.min(100, Number(range.value)));
                comparison.style.setProperty('--comparison-position', position + '%');
                range.setAttribute('aria-valuetext', range.dataset.beforeLabel + ': ' + position + '%, ' + range.dataset.afterLabel + ': ' + (100 - position) + '%');
            }

            range.addEventListener('input', update);
            range.addEventListener('change', update);
            // Keep dragging aligned with the image edges on every browser. The
            // native range still supplies keyboard controls and slider semantics.
            if (window.PointerEvent) {
                var activePointer = null;
                function movePointer(event) {
                    var bounds = comparison.getBoundingClientRect();
                    if (!bounds.width) return;
                    range.value = Math.round(Math.max(0, Math.min(100, (event.clientX - bounds.left) / bounds.width * 100)));
                    update();
                }
                range.addEventListener('pointerdown', function (event) {
                    if (!event.isPrimary || event.button !== 0) return;
                    event.preventDefault();
                    activePointer = event.pointerId;
                    range.focus({ preventScroll: true });
                    range.setPointerCapture(event.pointerId);
                    movePointer(event);
                });
                range.addEventListener('pointermove', function (event) {
                    if (event.pointerId === activePointer) movePointer(event);
                });
                function stopPointer(event) {
                    if (event.pointerId !== activePointer) return;
                    activePointer = null;
                    if (range.hasPointerCapture(event.pointerId)) range.releasePointerCapture(event.pointerId);
                }
                range.addEventListener('pointerup', stopPointer);
                range.addEventListener('pointercancel', stopPointer);
                range.addEventListener('lostpointercapture', stopPointer);
            }
            update();
            comparison.classList.add('is-enhanced');
            range.hidden = false;
            divider.hidden = false;
            comparison.querySelector('.comparison-help').hidden = false;
        });
    }

    function initReferenzen() {
        document.querySelectorAll('[data-referenzen]').forEach(function (portfolio) {
            if (portfolio.dataset.initialized === '1') return;
            portfolio.dataset.initialized = '1';
            var grid = portfolio.querySelector('.referenzen-mosaic');
            var filters = portfolio.querySelector('.referenzen-filters');
            if (!grid || !filters) return;
            var cards = Array.from(grid.querySelectorAll('.referenzen-card'));
            var buttons = Array.from(filters.querySelectorAll('[data-reference-filter]'));
            var status = portfolio.querySelector('.referenzen-status');

            function element(classes) {
                var node = document.createElement('div');
                node.className = classes;
                return node;
            }

            function slot(card, columns) {
                var node = element('referenzen-slot ' + columns);
                node.appendChild(card);
                return node;
            }

            // Rebuild Bootstrap rows after filtering so no empty mosaic slots remain.
            function render(items) {
                var fragment = document.createDocumentFragment();
                for (var offset = 0; offset < items.length; offset += 8) {
                    var chunk = items.slice(offset, offset + 8);
                    if (chunk.length >= 4) {
                        var feature = element('row referenzen-feature');
                        var main = element('col-lg-5 referenzen-feature-main');
                        var side = element('col-lg-7 referenzen-feature-side');
                        var row = element('row');
                        main.appendChild(slot(chunk[0], 'col-12 col-md-6 col-lg-12'));
                        row.appendChild(slot(chunk[1], 'col-12 col-md-6'));
                        row.appendChild(slot(chunk[2], 'col-12 col-md-6'));
                        row.appendChild(slot(chunk[3], 'col-12 col-md-6 col-lg-12'));
                        side.appendChild(row);
                        feature.appendChild(main);
                        feature.appendChild(side);
                        fragment.appendChild(feature);
                    }
                    var tail = chunk.length >= 4 ? chunk.slice(4) : chunk;
                    if (tail.length) {
                        var standard = element('row referenzen-standard');
                        tail.forEach(function (card, index) {
                            var columns = index === 3 || tail.length === 1 ? 'col-12' : (tail.length === 2 ? 'col-12 col-md-6' : 'col-12 col-md-6 col-lg-4');
                            standard.appendChild(slot(card, columns));
                        });
                        fragment.appendChild(standard);
                    }
                }
                grid.replaceChildren(fragment);
            }

            buttons.forEach(function (button) {
                button.addEventListener('click', function () {
                    if (button.getAttribute('aria-pressed') === 'true') return;
                    var category = button.dataset.referenceFilter;
                    var matching = cards.filter(function (card) {
                        return category === 'all' || card.dataset.referenceCategories.split(' ').includes(category);
                    });
                    render(matching);
                    buttons.forEach(function (item) {
                        var selected = item === button;
                        item.classList.toggle('is-active', selected);
                        item.setAttribute('aria-pressed', selected ? 'true' : 'false');
                    });
                    status.textContent = button.textContent.trim() + ': ' + matching.length + ' ' + portfolio.dataset.resultLabel;
                });
            });
            filters.hidden = false;
        });
    }

    $(function () {
        initBeforeAfter();
        initReferenzen();
        initTestimonials();
        initTimelines();
        initMarquees();
        initLightboxes();

        initCarousel('.gallery-slider.owl-carousel', {
            countAttribute: 'data-image-count',
            desktopItems: 1,
            tabletItems: 1,
            mobileItems: 1,
            gap: 24,
        });

        initCarousel('.block-cpt-slider.owl-carousel', {
            countAttribute: 'data-post-count',
            desktopItems: 3,
            tabletItems: 2,
            mobileItems: 1,
            gap: 24,
        });

        initCarousel('.taxonomy-posts-slider.owl-carousel', {
            countAttribute: 'data-post-count',
            desktopItems: 3,
            tabletItems: 2,
            mobileItems: 1,
            gap: 24,
        });

        initCarousel('.logos-slider.owl-carousel', {
            countAttribute: 'data-logo-count',
            desktopItems: 4,
            tabletItems: 3,
            mobileItems: 2,
            gap: 24,
        });

        initCarousel('.grid-card-slider.owl-carousel', {
            countAttribute: 'data-card-count',
            desktopItems: 3,
            tabletItems: 2,
            mobileItems: 1,
            gap: 24,
        });

        initSingleSlideCarousel('.text-image-slider.owl-carousel');

        $(window).on('load', refreshCarousels);
        $(window).on('resize orientationchange', debounce(refreshCarousels, 150));
    });
})(jQuery);
